import React, {useEffect} from 'react';
import {navigate} from '@reach/router';
import SalesIndex from '../join';

export default function (props) {
  useEffect(() => {
    navigate('/a-g/join/' + location.search);
  }, []);
  return <SalesIndex noFixedVideo noExitIntent variant="ad" />;
}
